import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1F4A50] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex flex-col leading-none mb-5">
            <span className="text-white text-3xl" style={{ fontFamily: "'Pacifico', cursive" }}>Website</span>
            <span className="text-[#D9A04A] text-xl -mt-1" style={{ fontFamily: "'Pacifico', cursive" }}>Symphony</span>
          </div>
          <p className="text-white/70 text-sm leading-relaxed mb-5">
            Custom website design, A.I. integration and inbound marketing services to help your business grow online.
          </p>
          <div className="flex items-center gap-3">
            {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D9A04A] flex items-center justify-center transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-[#D9A04A] font-bold mb-5 tracking-wider text-sm">SERVICES</h4>
          <ul className="space-y-2 text-white/80 text-sm">
            <li><Link to="/web-design" className="hover:text-[#D9A04A] transition-colors">Web Design</Link></li>
            <li><Link to="/web-design-for-med-spas" className="hover:text-[#D9A04A] transition-colors">Web Design for Med Spas</Link></li>
            <li><Link to="/web-design-for-tattoo-shops" className="hover:text-[#D9A04A] transition-colors">Web Design for Tattoo Shops</Link></li>
            <li><Link to="/web-design-for-construction-companies" className="hover:text-[#D9A04A] transition-colors">Construction Companies</Link></li>
            <li><Link to="/web-design-for-oil-rig-companies" className="hover:text-[#D9A04A] transition-colors">Oil Rig &amp; Energy</Link></li>
            <li><Link to="/ai" className="hover:text-[#D9A04A] transition-colors">A.I. Integration</Link></li>
            <li><Link to="/marketing" className="hover:text-[#D9A04A] transition-colors">Marketing &amp; SEO</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[#D9A04A] font-bold mb-5 tracking-wider text-sm">COMPANY</h4>
          <ul className="space-y-2 text-white/80 text-sm">
            <li><Link to="/" className="hover:text-[#D9A04A] transition-colors">About Us</Link></li>
            <li><Link to="/portfolio" className="hover:text-[#D9A04A] transition-colors">Portfolio</Link></li>
            <li><Link to="/blog" className="hover:text-[#D9A04A] transition-colors">Blog</Link></li>
            <li><Link to="/" className="hover:text-[#D9A04A] transition-colors">Company Blog</Link></li>
            <li><Link to="/" className="hover:text-[#D9A04A] transition-colors">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-[#D9A04A] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[#D9A04A] font-bold mb-5 tracking-wider text-sm">GET IN TOUCH</h4>
          <ul className="space-y-3 text-white/80 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-[#D9A04A] mt-1 flex-shrink-0" />
              <span>420 NE 67th St, Suite 711-North, Miami Beach, FL 33141</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#D9A04A]" />
              <a href="tel:+13058125999" className="hover:text-[#D9A04A] transition-colors">(305) 812-5999</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#D9A04A]" />
              <a href="mailto:Info@WebsiteSymphony.com" className="hover:text-[#D9A04A] transition-colors">Info@WebsiteSymphony.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-sm">© {new Date().getFullYear()} Website Symphony. All Rights Reserved.</p>
          <div className="flex items-center gap-5 text-sm text-white/60">
            <a href="#" className="hover:text-[#D9A04A] transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-[#D9A04A] transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-[#D9A04A] transition-colors">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
